import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconButton } from '@ff-os/shared-react/components/buttons/icon-button/IconButton';
import { Icon } from '@ff-os/shared-react/components/icons/Icon';
import { WindowBody } from '@ff-os/shared-react/components/window/partials/WindowBody';
import { WindowHeader } from '@ff-os/shared-react/components/window/partials/WindowHeader';
import { Window } from '@ff-os/shared-react/components/window/Window';
import { useClickOutside } from '@ff-os/shared-react/hooks/useClickOutside';
import classNames from 'classnames';
import { selectHasFotofunBorder } from '../../_redux-borders';
import { selectisFotofunPanelOpen, setisFotofunPanelOpen } from '../../_redux-ui';
import { FotoFunButton } from '../fotofun/components/FotoFunButton';
import { PhotoPrintsOrderButton } from '../PhotoPrintsOrderButton';
import { PhotoPrintsWindowErrors } from '../PhotoPrintsWindowErrors';
import { PhotoPrintGroupsGrid } from './PhotoPrintGroupsGrid';
import { PhotoPrintsDropzone } from './PhotoPrintsDropzone';
import styles from './PhotoPrintsWindowDesktop.module.scss';

export const PhotoPrintsWindowDesktop = ({ close }: Props) => {

    const dispatch = useDispatch();
    const hasFotofunBorder = useSelector(selectHasFotofunBorder);
    const IsFotofunPanelOpen = useSelector(selectisFotofunPanelOpen);

    const fotoFunButtonRef = useRef<HTMLButtonElement>(null);
    const fotofunPanelRef = useRef<HTMLDivElement>(null);
    const photoPrintGroupsRef = useRef<HTMLDivElement>(null);
    const orderButtonRef = useRef<HTMLDivElement>(null);

    const closeFotofunPanel = () => {
        dispatch(setisFotofunPanelOpen(false));
    };

    useClickOutside(
        [
            fotoFunButtonRef as React.RefObject<HTMLElement>, 
            fotofunPanelRef as React.RefObject<HTMLElement>, 
            photoPrintGroupsRef as React.RefObject<HTMLElement>, 
            orderButtonRef as React.RefObject<HTMLElement>
        ] as Array<React.RefObject<HTMLElement>>,
        () => {
            if (IsFotofunPanelOpen) {
                closeFotofunPanel();
            }
        }
    );

    const headerClassName = classNames(styles.header,
        {
            [styles.fotofunPanelActive]: IsFotofunPanelOpen
        }
    );

    return (
        <Window fullHeight fullWidth close={close}>
            <WindowHeader>
                <div className={headerClassName}>
                    <div className={styles.headerButtons}>
                        <IconButton small
                            onClick={close}>
                            <Icon type='general-ui-close' strokeWidth={2} size='small' />
                        </IconButton>
                        {hasFotofunBorder && <FotoFunButton ref={fotoFunButtonRef} />}
                    </div>
                    <PhotoPrintsOrderButton ref={orderButtonRef} className={styles.orderButton} />
                </div>
            </WindowHeader>
            <WindowBody>
                <PhotoPrintsDropzone fotofunPanelRef={fotofunPanelRef} photoPrintGroupsRef={photoPrintGroupsRef}>
                    <PhotoPrintGroupsGrid />
                </PhotoPrintsDropzone>
            </WindowBody>
            <PhotoPrintsWindowErrors />
        </Window>
    );
};

type Props = {
    close: () => void;
};